/*
 * Copyright © Cisco Systems, Inc. — All rights reserved.
 */

// (air quotes) “Temporary” until we merge the build pipeline with platform.
// These are all provided by platform, so just referencing them.
const $ = window.$;
const _ = window._;
const angular = window.angular;
const d3 = window.d3;
const moment = window.moment;

export {
    $,
    _,
    angular,
    d3,
    moment
};
